import { observer } from 'mobx-react-lite';
import { TradePlanData } from '../../../../../../../classes/tradePlan/tradePlanData';
import { useTradePlanFormStore } from '../../../../../../../classes/tradePlan/tradePlanProvider';
import { OptionChainsTableRow } from './OptionChainsTableRow';
import { OptionData } from './optionType';

export const OptionChainsPuts = observer(() => {
  const tradePlanForm: TradePlanData = useTradePlanFormStore();
  const optionManagement = tradePlanForm.optionManagement;
  const selectedPuts = optionManagement.selectedOptions.puts;

  return (
    <>
      {selectedPuts.map((put: OptionData) => (
        <OptionChainsTableRow key={put.symbol} type="Put" data={put} />
      ))}
    </>
  );
});
